import React from 'react'
import ApproveReportModal from './ApproveReportModal'

const RejectReportModal = (props) => (
  <ApproveReportModal
    {...props}
    submitText="reject"
  />
)

export default RejectReportModal
